import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"page-top-navigation"},[_c(VTabs,{attrs:{"value":_vm.selectedTab,"dark":"","dense":"","flat":"","hide-slider":"","background-color":"transparent"}},_vm._l((_vm.tabsData),function(tab,index){return _c(VTab,{key:index,attrs:{"tab-value":index},on:{"click":function($event){return _vm.navigate(tab.route)}}},[_vm._v(" "+_vm._s(tab.text)+" ")])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }